angular.module('lf.common')

.directive('validPassword', function (validationService) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, el, attrs, model) {
      var validator = function (val) {
        var valid = model.$isEmpty(val) || validationService.validatePassword(val);
        model.$setValidity('validPassword', valid);
        return val;
      }
      model.$parsers.push(validator);
      model.$formatters.push(validator);
    }
  }
});
